import { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "../components/ScrollToTop";
import Layout from "../layouts/Layout";
import Home from "../pages/Home";
import CalculatorPage from "../pages/CalculatorPage";
import AboutUs from "../pages/AboutUs";
import ContactUs from "../pages/ContactUs";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import Disclaimer from "../pages/Disclaimer";
import TermsConditions from "../pages/TermsConditions";
import FinancialGuides from "../pages/FinancialGuides";
import ArticlePage from "../pages/ArticlePage";

export function AppContent() {
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <>
      <ScrollToTop />
      <Layout searchQuery={searchQuery} setSearchQuery={setSearchQuery}>
        <Routes>
          {/* Main Dashboard Landing */}
          <Route 
            path="/" 
            element={
              <Home 
                searchQuery={searchQuery} 
                setSearchQuery={setSearchQuery} 
              />
            } 
          />

          {/* Compliance & Editorial Pages */}
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/terms" element={<TermsConditions />} />
          <Route path="/guides" element={<FinancialGuides />} />
          <Route path="/blog" element={<FinancialGuides />} />
          <Route path="/blog/:slug" element={<ArticlePage />} />

          {/* Dynamic Router for all 77+ SEO Calculators */}
          <Route path="/:slug" element={<CalculatorPage />} />

          {/* Wildcard Fallback redirects straight home */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Layout>
    </>
  );
}
